<template>
  <div class="partner-benefits-box">
    <h4 class="partner-benefits-box__title">
      {{ benefits?.title }}
    </h4>
    <ul class="partner-benefits-box__list">
      <li
        v-for="(benefit, index) in benefits?.items"
        :key="index"
        class="partner-benefits-box__item"
      >
        <CheckGeneric class="partner-benefits-box__icon" />
        <span>{{ benefit }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import CheckGeneric from '~/assets/icons/check-generic.svg?component'

const props = defineProps<{
  benefits?: {
    title: string
    items: string[]
  }
}>()
</script>

<style lang="postcss" scoped>
.partner-benefits-box {
  @apply bg-teal-50 rounded-lg p-4 border border-gray-200;
}

.partner-benefits-box__title {
  @apply text-base font-normal text-gray-900 mb-3 leading-4;
}

.partner-benefits-box__list {
  @apply space-y-2;
}

.partner-benefits-box__item {
  @apply flex gap-2 text-caption text-gray-700;
}

.partner-benefits-box__icon {
  @apply text-teal-600 flex-shrink-0;
  @apply w-4 h-4 mt-0.5;
}
</style>
